const deleteRoles = {
  toastr: 'Sitio eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteRoles;
